import Convert from 'ansi-to-html';
import { format } from 'date-fns';
// @ts-ignore
import { escape } from 'he';
import { omitBy } from 'lodash';
import moment from 'moment';
import YAML from 'yaml';
import { env } from 'next-runtime-env';

export const isExists = (value: any = undefined) =>
  value !== undefined && value !== null;

export const isNotExists = (value: any = undefined) => !isExists(value);

export const paramsToQueryString = (params = {}, additionalParams = false) => {
  if (!isExists(params)) return '';
  return `${additionalParams ? '&' : '?'}${new URLSearchParams({ ...omitBy(params, isNotExists) }).toString()}`;
};

const timeZoneTimestamp = new Date().getTimezoneOffset() * 60000;

export const convertDateTimeStamp = (timestamp: Date) => {
  return moment(Date.parse(timestamp.toString()) - timeZoneTimestamp).format(
    'DD/MM/YY HH:mm:ss'
  );
};

const ansiToHtml = (input: string) => {
  const convert = new Convert();
  return convert.toHtml(input);
};

export const convertLogText = (text: string) => {
  return ansiToHtml(escape(text));
};

export const urlEncodedDateTime = (date: Date | undefined) => {
  if (!date) return '';
  return format(date, "yyyy-MM-dd'T'HH:mm:ssXXX");
};

export const downloadConfigFile = (values: any) => {
  const configContent = YAML.stringify(values);
  const file = new Blob([configContent], { type: 'text/plain' });

  const element = document.createElement('a');
  element.href = URL.createObjectURL(file);
  element.download = 'amvera.yml';

  document.body.appendChild(element);
  element.click();
  // @ts-ignore
  element.parentNode.removeChild(element);
};

export const getQuarterFromDate = (date: Date | undefined) => {
  if (!date) return '';

  const month = date.getMonth();
  return `Q${Math.floor(month / 3) + 1}`;
};

export function downloadFile({
  linkAddress,
  newTab = false,
}: {
  linkAddress: string;
  newTab?: boolean;
}) {
  const link = document.createElement('a');
  link.href = linkAddress;

  if (newTab) {
    link.target = '_blank';
  }

  document.body.appendChild(link); // 4. Force download
  link.click(); // 5. Clean up and remove the link
  link?.parentNode?.removeChild(link);
}

export const IS_INTERNATIONAL = () => {
  return env('NEXT_PUBLIC_AMVERA_REGION') === 'waw';
};

// console.log('from util.ts isInternational:', IS_INTERNATIONAL());
// console.log(
//   'from util.ts current region',
//   process.env.NEXT_PUBLIC_AMVERA_REGION
// );

export const DOCS_DOMAIN = IS_INTERNATIONAL()
  ? 'https://docs.amverum.com'
  : 'https://docs.amvera.ru';

export function unixTimestampFromDate(date: Date | undefined) {
  if (!date) {
    return date;
  }
  return Math.floor(date.getTime() / 1000);
}

export function unixTimestampToTime(timestamp: number) {
  return moment.unix(timestamp).format('HH:mm');
}

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    'Bytes',
    'KiB',
    'MiB',
    'GiB',
    'TiB',
    'PiB',
    'EiB',
    'ZiB',
    'YiB',
  ];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))}\xa0${sizes[i]}`;
}

export function isObjectEmpty(obj: Object | undefined) {
  if (!obj) return true;
  // eslint-disable-next-line no-restricted-syntax
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}

export function getDomainName(slug: string, ownerName: string) {
  return IS_INTERNATIONAL() ? `run-${slug}` : `amvera-${ownerName}-run-${slug}`;
}

export function getDomainNameCnpg(
  slug: string,
  ownerName: string,
  type: 'rw' | 'ro' | 'r'
) {
  return IS_INTERNATIONAL()
    ? `cnpg-${slug}-${type}`
    : `amvera-${ownerName}-cnpg-${slug}-${type}`;
}
